import { CartProduct, Product } from "@/types/product";
import * as Sentry from "@sentry/react";
import { logger } from "./logger";

/**
 * Converts a Product object to a CartProduct object considering primary_variant_id
 */
export const productToCartProduct = (product: Product): CartProduct => {
  const { productId, variant } = getVariantData(product);

  return {
    id: productId,
    title: product.title,
    price: variant?.price,
    variant_id: variant?.id,
    quantity: 1,
    image: variant?.image?.src,
  };
};

const getVariantData = (product: Product) => {
  const primaryVariant = product.variants.filter(
    (variant) => variant.id === product.primary_variant_id,
  )[0];
  const variantImage = product.images.filter(
    (img) => img.product_id === primaryVariant?.id,
  )[0];
  const fallbackVariant = product.variants[0];
  const fallbackImage = product.images[0];

  if (!variantImage) {
    logger.log("No variant image found, using fallback", {
      product,
      variantImage,
      fallbackImage,
    });
    Sentry.captureMessage("No variant image found, using fallback", {
      extra: { product, variantImage, fallbackImage },
    });
  }

  const variant = primaryVariant || fallbackVariant;

  return {
    productId: product.id.toString(),
    variant: {
      ...variant,
      image: variantImage || fallbackImage,
    },
  };
};
